import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../helpers/api_helper';
import { DirectBonusState, DirectBonusType } from './types';
import { toast } from 'react-toastify';
import { handleValidDate, handleValidTime } from '../../../helpers/helpers';
import { statusForTable } from '../MatchingBonus/slice';

export const getDirectBonus = createAsyncThunk(
  'getDirectBonus/fetch',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get(`/bonus/direct/`, {
      params
    });

    return response.data.data;
  }
);

export const exportDirectBonus = createAsyncThunk(
  'getDirectBonus/exportDirectBonus',
  async (params: URLSearchParams) => {
    const response = await axiosInstance.get('/bonus/direct/export', {
      params
    });

    try {
      if (response?.data?.data?.userDirectBonuses) {
        const dataForExport = response?.data?.data?.userDirectBonuses.map(
          (u: any) => {
            return {
              id: u?.id,
              userId: u?.userId,
              userPackageId: u?.userPackageId,
              packagePrice: u?.userPackage?.price,
              comissionPercent: u?.comissionPercent,
              comissionAmount: u?.comissionAmount,
              dateCreated: u?.dateCreated
                ? `${handleValidDate(u.dateCreated)}, ${handleValidTime(
                    u.dateCreated
                  )}`
                : '',
              status: statusForTable(u?.status)
            };
          }
        );

        return dataForExport;
      }

      if (response.data.message) {
        toast.success(response.data.message);
      }
    } catch (error: any) {
      toast.error(error.response.data.error);
    }
  }
);

export const exportHeaders = [
  { label: 'Bonus ID', key: 'id' },
  { label: 'User', key: 'userId' },
  { label: 'Order Id', key: 'userPackageId' },
  { label: 'Comission Percent', key: 'comissionPercent' },
  { label: 'Amount', key: 'comissionAmount' },
  { label: 'Package Price', key: 'packagePrice' },
  { label: 'Date Created', key: 'dateCreated' },
  { label: 'Status', key: 'status' }
];

const initialState = {
  data: {},
  loading: false,
  dataForExport: [],
  totalCount: 0,
  loadingExport: false
} as DirectBonusState;

const getDirectBonusSlice = createSlice({
  name: 'getDirectBonus',
  initialState,
  reducers: {
    removeDirectBonusForExport(state) {
      state.dataForExport = [];
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getDirectBonus.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getDirectBonus.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.data = payload;
      state.totalCount = payload.count;
    });
    builder.addCase(getDirectBonus.rejected, (state) => {
      state.loading = false;
    });

    //loading export
    builder.addCase(exportDirectBonus.pending, (state) => {
      state.loadingExport = true;
    });
    builder.addCase(exportDirectBonus.fulfilled, (state, { payload }) => {
      state.loadingExport = false;
      state.dataForExport = payload;
    });
    builder.addCase(exportDirectBonus.rejected, (state) => {
      state.loadingExport = false;
    });
  }
});

export const { removeDirectBonusForExport } = getDirectBonusSlice.actions;

export default getDirectBonusSlice.reducer;
